// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2Z45m","left":"styles_left__2S8oE","right":"styles_right__1dRTf","alert":"styles_alert__1gxjQ"};